import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function B() {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);

    return (
        <section id="dpu-detail-B" className={`dpu-detail-B dpu-detail-section ${css['dpu-detail-B']}`}>
            <EfSpec />
            <ul className="videos">
                <li className={`video ${active === 0 ? 'active' : ''}`}>
                    <video
                        src={`/responsive/video/delta-pro-ultra/launch/2_1.mp4`}
                        autoPlay={true}
                        loop={true}
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/delta-pro-ultra/launch/2_1.jpg"
                        aria-label={t('secB_tab1')}
                    />
                    <div className="float-msg">
                        <svg className="light-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.93401 13.8007L10.2631 19.5668L10.8833 19.2087L0.62021 1.43259L0 1.79067L2.7367 6.53077L0.000196251 10.6528H3.76002L2.86483 20.5L6.93401 13.8007ZM7.73947 12.4747L3.57698 5.26502L7.07225 0L6.71417 8.41485H10.2054L7.73947 12.4747Z"
                                fill="white"
                            />
                        </svg>
                        <p className="icon-text">{t('secB_icon')}</p>
                    </div>
                </li>
                <li className={`video ${active === 1 ? 'active' : ''}`}>
                    <video
                        src={'/responsive/video/delta-pro-ultra/launch/2_2.mp4'}
                        autoPlay={true}
                        loop={true}
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/delta-pro-ultra/launch/2_2.jpg"
                        aria-label={t('secB_tab2')}
                    />
                </li>
            </ul>
            <ul className="tabs">
                <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => setActive(0)}>
                    {t('secB_tab1')}
                </li>

                <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => setActive(1)}>
                    {t('secB_tab2')}
                </li>
            </ul>
            <div className="info">
                <h2 className="title">{t('secB_title')}</h2>
                <p className="desc">
                    {t.rich(`secB_desc${active + 1}`, {
                        w: (text: any) => <span className="white-text">{text}</span>,
                        n: (text: any) => <span className="no-wrap">{text}</span>,
                        sup: (text: any) => <sup className="sup">{text}</sup>,
                    })}
                </p>
            </div>
        </section>
    );
}
